<form [formGroup]>
    <ng-container *ngIf="formGroup">
        <div
            class="my-4 border-b border-solid px-4 dark:border-contrast-yellow"
            *ngIf="env.JOURNEY_PLANNER?.FILTERS?.TRANSPORT_MODE">
            <h3
                class="mb-4 overflow-hidden text-xs font-semibold uppercase tracking-wider text-ironside_grey dark:text-contrast-yellow"
                [class.normal-case]="env.REMOVE_UPPERCASE">
                {{ 'PLANNER_FILTER_TYPE_OF_TRAFFIC' | translate }}
            </h3>
            <div class="h-auto overflow-y-auto">
                <rwidget-journey-planner-filter-transport-mode [values]="transportModeValues" [formGroup]="formGroup">
                </rwidget-journey-planner-filter-transport-mode>
            </div>
        </div>

        <ng-container *ngIf="env.JOURNEY_PLANNER?.FILTERS?.SELECTORS && formGroup">
            <div
                class="my-4 px-4 dark:border-contrast-yellow"
                *ngFor="let selector of env.JOURNEY_PLANNER?.FILTERS.SELECTORS; let last = last"
                [class.border-b]="!last"
                [class.border-solid]="!last">
                <h3
                    class="mb-4 overflow-hidden text-xs font-semibold uppercase tracking-wider text-ironside_grey dark:text-contrast-yellow"
                    [class.normal-case]="env.REMOVE_UPPERCASE">
                    {{ selector.TITLE_KEY | translate }}
                </h3>
                <div class="flex h-auto flex-wrap overflow-y-hidden">
                    <rwidget-journey-planner-filter-slider
                        *ngIf="selector.TYPE === 'SLIDER'; else notSlider"
                        [values]="selector.VALUES"
                        [formItem]="selector.QUERY_PARAMETER"
                        [formItemInitValue]="formGroup.controls[selector.QUERY_PARAMETER].value ?? selector.INIT_VALUE"
                        [formGroup]="formGroup">
                    </rwidget-journey-planner-filter-slider>
                    <ng-template #notSlider>
                        <rwidget-journey-planner-filter-via-point
                            *ngIf="selector.TYPE === 'VIA_POINT'; else defaultChips"
                            [formGroup]="formGroup"
                            [formItem]="selector.QUERY_PARAMETER">
                        </rwidget-journey-planner-filter-via-point>

                        <ng-template #defaultChips>
                            <rwidget-journey-planner-filter-chips
                                [values]="selector.VALUES"
                                [formGroup]="formGroup"
                                [formItem]="selector.QUERY_PARAMETER"
                                [multiple]="selector.TYPE === 'MULTI_SELECTION'">
                            </rwidget-journey-planner-filter-chips>
                        </ng-template>
                    </ng-template>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="showRoutes">
            <rwidget-journey-planner-filter-route
                [selectedRoutes]="formGroup.get('routes').value"
                (filterChanged)="filterRouteChangedHandler($event)"></rwidget-journey-planner-filter-route>
            <mat-divider></mat-divider>
        </ng-container>
    </ng-container>
</form>
